import React from "react";
import ProductCategory from "../../productcategory2";
import SEO from "../../seo";

import orthocareet from "../../../images/remattressorientation/ortho care  ET.png";
import orthocare from "../../../images/remattressorientation/ortho care.png";

export default function OrthoMattressPage() {
  const data = {
    categoryName: "Ortho Series",
    description:
      "Ortho Series by Eclipse is the culmination of years of research and development. As our spines are naturally curved, a very hard mattress can cause aches and pains on our delicate pressure points, which is why Eclipse’s Ortho Series – the most advance version of the firm mattress – has been uniquely designed to achieve a balance between support and comfort. These Orthopedic mattresses are best mattress for back pain that made of Eclipse high density PUF to provide enhanced lumbar support and quilted with a soft and plush steam-treated fabric.",
    benefits: [
      "Adjusts to the natural shape of your spine",
      "Achieves a balance between support and comfort",
      "Made of Eclipse high density PUF to provide enhanced lumber support",
      "Quilted with a soft and plush steam-treated fabric",
    ],
    products: [
      {
        img: orthocareet,
        name: "ORTHO CARE ET",
        link: "/ortho-mattress/ortho-care-et/",
        startingAt: "₹13,099",
      },
      {
        img: orthocare,
        name: "ORTHO CARE",
        link: "/ortho-mattress/ortho-care/",
        startingAt: "₹11,499",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-3.png",
        name: "ORTHOTONIC",
        link: "/ortho-mattress/orthotonic/",
        startingAt: "₹9,299",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2021/06/Orthospine_1000X667.png",
        name: "ORTHOSPINE",
        link: "/ortho-mattress/orthospine/",
        startingAt: "₹8,499",
      },
    ],

    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Ortho-Collection-Brochure.pdf",
    actionToAccess: false,
    banner: "https://eclipsemattress.in/assets/images/banners/ortho-d.jpg",
    bannerSm: "https://eclipsemattress.in/assets/images/banners/ortho-m.jpg",
  };
  return (
    <div>
      <SEO
        title="Ortho Series | Eclipse International"
        description="Buy ortho series of orthopedic mattresses in India at the best prices. Explore the various series of ortho mattress as per your need and comfort from India's best mattress manufacturer."
        img="https://eclipsemattress.in/assets/linkpreviews/category/ortho-mattress.jpg"
      />
      <ProductCategory category={data} />
    </div>
  );
}
